export var H24_IMG_WIDTH = ['86.5px', '93px', '118px'];
export var H24_IMG_HEIGHT = ['30.8px', '33px', '42px'];
export var FFH_IMG_WIDTH = ['45px', null, '122px'];
export var FFH_IMG_HEIGHT = ['32px', null, '88px'];
